var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("toolbar"),
      _vm._v(" "),
      _c("zlick-navigation"),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", center: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "offset-xs0": "" } },
                [
                  _c(
                    "v-form",
                    {
                      ref: "changePassword",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("current_password"),
                          type: "password",
                          name: "currentPassword",
                          placeholder: "",
                          rules: _vm.PasswordRules,
                          autocomplete: "off",
                          "validate-on-blur": "",
                          required: ""
                        },
                        model: {
                          value: _vm.currentPassword,
                          callback: function($$v) {
                            _vm.currentPassword = $$v
                          },
                          expression: "currentPassword"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("new_password"),
                          type: "password",
                          name: "newPassword",
                          placeholder: "",
                          rules: _vm.PasswordRules,
                          autocomplete: "off",
                          "validate-on-blur": "",
                          required: ""
                        },
                        model: {
                          value: _vm.newPassword,
                          callback: function($$v) {
                            _vm.newPassword = $$v
                          },
                          expression: "newPassword"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("confirm_password"),
                          type: "password",
                          name: "newPassword",
                          placeholder: "",
                          rules: _vm.MatchingPasswords,
                          autocomplete: "off",
                          "validate-on-blur": "",
                          required: ""
                        },
                        model: {
                          value: _vm.newPassword2,
                          callback: function($$v) {
                            _vm.newPassword2 = $$v
                          },
                          expression: "newPassword2"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { disabled: !_vm.valid },
                          on: { click: _vm.submit }
                        },
                        [_vm._v(_vm._s(_vm.$t("submit")))]
                      ),
                      _vm._v(" "),
                      _c("v-btn", { on: { click: _vm.clear } }, [
                        _vm._v(_vm._s(_vm.$t("cancel")))
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.error
                        ? _c("h3", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(_vm.error))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e7ce31b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e7ce31b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = null
// module chunks = 